import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ResourceIdType } from '../../../domain/model/resource-id-type.enum';
import { Modulo10Validator } from './utils/modulo10.validator';

export class ResourceIdValidator {
    private static readonly STEUERBARE_RESOURCE_PATTERN = new RegExp('^C[A-Z\\d]{9}\\d$');
    private static readonly TECHNISCHE_RESOURCE_PATTERN = new RegExp('^D[A-Z\\d]{9}\\d$');
    private static readonly STEUERGRUPPE_PATTERN = new RegExp('^B[A-Z\\d]{9}\\d$');

    static validate(resourceIdType: ResourceIdType): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }

            const pattern = this.getRegex(resourceIdType);
            if (!control.value || !control.value.toString().match(pattern)) {
                return { pattern: true };
            } else if (!this.isCheckDigitCalculationValid(control.value.toString())) {
                return { checkDigit: true };
            }
            return null;
        };
    }

    private static getRegex(type: ResourceIdType): RegExp {
        switch (type) {
            case ResourceIdType.STEUERBARE_RESOURCE_ID:
                return this.STEUERBARE_RESOURCE_PATTERN;
            case ResourceIdType.TECHNISCHE_RESOURCE_ID:
                return this.TECHNISCHE_RESOURCE_PATTERN;
            case ResourceIdType.STEUERGRUPPE_ID:
                return this.STEUERGRUPPE_PATTERN;
        }
    }

    private static isCheckDigitCalculationValid(resourceId: string): Boolean {
        const convertedId = this.convertIdToNumberValues(resourceId);
        return Modulo10Validator.isValid(convertedId);
    }

    private static convertIdToNumberValues(resourceId: string): number[] {
        return [
            ...resourceId,
        ].map(value => this.convertCharToNumberValue(value));
    }

    private static convertCharToNumberValue(character: string): number {
        const value = parseInt(character);
        if (isNaN(value)) {
            return character.charCodeAt(0);
        } else {
            return value;
        }
    }
}
